import React, { useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams,useLocation } from "react-router-dom";
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import copy from "copy-to-clipboard";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SATextArea from "../components/SATextArea";
import BlockHeading from "../components/BlockHeading";
import BottomNavBar from "../components/BottomNavBar";
import StepAway from "../components/StepAway";
import * as workActivitiesAPI from "../services/workActivities";
import toast, { toastConfig } from 'react-simple-toasts';

export default function WorkActivities() {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();
    
    const [loader, setLoader] = useState(false)
    const [copyUrl, setCopyUrl] = useState('');
    const [studHCode, setHexCode] = useState('');

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues:
        {
            workExperience: '',
            schoolActivities: '',
            communityActivities: ''
        }
    })

    useEffect(() => {
        document.title = 'Work/Activities | Families of WWII Veterans';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []); 

    useEffect(() => {
       let hexCode =location?.state?.hexCode? location.state.hexCode : "";
        if(hexCode === ""){
            hexCode = searchParams.get("code");
        }
        setHexCode(hexCode);
        let modifiedURL = window.location.href.search("code")
        let url = ""
        if (modifiedURL > -1) {
            url = `${window.location.href}`
        } else {

            url = `${window.location.href}?code=${hexCode}`
        }
        setCopyUrl(url)
        
    }, [location?.state?.hexCode,searchParams]); 

    

    const getActivitiesApi = useCallback(async () => {
        setLoader(true)
        try {
            await workActivitiesAPI.getWorkActivities(`student/${studHCode}/activities`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let activitiesData = res.data;
                    reset({
                        studentId: activitiesData.studentId,
                        studentHexCode: activitiesData.studentHexCode,
                        workExperience: activitiesData.workExperience,
                        schoolActivities: activitiesData.schoolActivities,
                        communityActivities: activitiesData.communityActivities
                    })
                }else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            }).catch(function (error) {
                setLoader(false)
                toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                return error
            });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [reset,studHCode])

    useEffect(() => {
        if (studHCode) {
            getActivitiesApi()
        }
        
    }, [getActivitiesApi,studHCode]); 

    const handleBack = () => {
        navigate("/college-university-considering",{
            state:{hexCode : studHCode}
        })
    }
    const handleNavBack = (to) => {
        navigate(to,{
            state:{hexCode : studHCode}
        })
    }

    const onSubmit = async (data) => {
        let activitieObj = {

            "workExperience": data.workExperience,
            "schoolActivities": data.schoolActivities,
            "communityActivities": data.communityActivities
        }
        setLoader(true)
        try {
            await workActivitiesAPI.postWorkActivities(activitieObj, `student/${studHCode}/activities`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    navigate("/review",{
                        state:{hexCode : studHCode}
                    })
                } else if (res.status === 422) {
                    let errorData = res?.data?.errors
                    if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                        Object.keys(errorData).forEach((err, index) => {
                            toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                        })
                    }
                } else {
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
        }
    }
    const handleCopy = () => {
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);

    }

    return (
        <>
            <Header title="Scholarship Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <StepAway handleCopy={handleCopy} copyInputValue={copyUrl} />
                        <Nav navbType="student" handleNavBack={handleNavBack}/>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BlockHeading title={"Work Experience, School & Community Activities"} />
                            <Row>
                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"workExperience"}
                                        name={"workExperience"}
                                        label={"Work Experience:"}
                                        isStrong={true}
                                        requiredObj={{ required: "Work Experience is required!", maxLength: { value: 400, message: "Max length is 400 characters!" } }}
                                        placeholder={"List any paid positions that you have held during the past four years, including summer employment, beginning with your most recent position. (required)"}
                                        maxLength={400}
                                        id={"WorkExperienceHelp"}
                                        errMsg={errors.workExperience?.message}
                                    />
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"schoolActivities"}
                                        name={"schoolActivities"}
                                        label={"School Activities:"}
                                        isStrong={true}
                                        requiredObj={{ required: "School Activities is required!", maxLength: { value: 400, message: "Max length is 400 characters!" } }}
                                        placeholder={"List school and club activities or sports you have participated in during the past four years. Please list the activities in order of your interest. (required)"}
                                        maxLength={400}
                                        id={"schoolActivitiesHelp"}
                                        errMsg={errors.schoolActivities?.message}
                                    />
                                </Col>
                            </Row>
                            <hr />

                            <Row>
                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"communityActivities"}
                                        name={"communityActivities"}
                                        label={"Community Activities:"}
                                        isStrong={true}
                                        requiredObj={{ required: "Community Activities is required!", maxLength: { value: 400, message: "Max length is 400 characters!" } }}
                                        placeholder={"List community and religious activities or sports you have participated in during the past four years. Please list the activities in order of your interest. (required)"}
                                        maxLength={400}
                                        id={"communityActivitiesHelp"}
                                        errMsg={errors.communityActivities?.message}
                                    />
                                </Col>
                            </Row>


                            <BottomNavBar handleBack={handleBack}
                                submitButtonTitle="REVIEW" />
                        </form>

                    </Col>
                </Row>
            </Container>
            <Footer />

        </>
    );
}